import React from 'react';
import I18n from 'utils/I18n';
import PropTypes from 'prop-types';

import styles from './index.scss';
import ButtonWrapper, { LOG_IN, SIGN_UP } from '../ButtonWrapper';

const AccountAuthEmailButton = ({ type, onClick }) => {
  const I18nPrefix = 'strava.landing_page';

  return (
    <ButtonWrapper
      className={styles.emailButton}
      onClick={onClick}
      data-testid="email_auth_btn"
    >
      {type === SIGN_UP
        ? I18n.t(`${I18nPrefix}.here_to_join.email_cta`)
        : 'implement_me'}
    </ButtonWrapper>
  );
};

AccountAuthEmailButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOf([SIGN_UP, LOG_IN]).isRequired
};

AccountAuthEmailButton.defaultProps = {
  onClick: () => {}
};

export default AccountAuthEmailButton;
